const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_636",
  "data-name": "Rectangle 636",
  width: 74,
  height: 74,
  fill: "#e3021c"
})));
var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Group_512",
  "data-name": "Group 512",
  transform: "translate(0.079 0.079)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_511",
  "data-name": "Group 511",
  transform: "translate(-0.079 -0.079)",
  clipPath: "url(#clip-path)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_174",
  "data-name": "Path 174",
  d: "M36.954,73.907A36.954,36.954,0,1,0,0,36.954,37,37,0,0,0,36.954,73.907m0-70.612A33.658,33.658,0,1,1,3.3,36.954,33.7,33.7,0,0,1,36.954,3.3",
  transform: "translate(0.093 0.093)",
  fill: "#e3021c"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_175",
  "data-name": "Path 175",
  d: "M96.135,98.557a6.824,6.824,0,1,0-6.823-6.824,6.823,6.823,0,0,0,6.823,6.824m0-10.352a3.528,3.528,0,1,1-3.528,3.528,3.528,3.528,0,0,1,3.528-3.528",
  transform: "translate(-68.197 -64.832)",
  fill: "#e3021c"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_176",
  "data-name": "Path 176",
  d: "M164.953,179.691a6.824,6.824,0,1,0,6.823-6.824,6.823,6.823,0,0,0-6.823,6.824m10.352,0a3.528,3.528,0,1,1-3.529-3.529,3.528,3.528,0,0,1,3.529,3.529",
  transform: "translate(-126.035 -132.086)",
  fill: "#e3021c"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_177",
  "data-name": "Path 177",
  d: "M101.27,112.866a1.648,1.648,0,0,0,2.28-.48l23.291-35.712a1.648,1.648,0,1,0-2.76-1.8L100.79,110.586a1.647,1.647,0,0,0,.48,2.28",
  transform: "translate(-76.769 -56.584)",
  fill: "#e3021c"
})));
function SvgIconPercentage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPercentage);
export default __webpack_public_path__ + "static/media/icon-percentage.e9eb97c4.svg";
export { ForwardRef as ReactComponent };